import React from 'react'
import ReactDOM from 'react-dom/client'
import './assets/sass/app.scss'
import './assets/styles/app.css'
import './assets/styles/fontawesome/css/all.min.css'
import 'react-tooltip/dist/react-tooltip.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import {Provider} from 'react-redux'
import {store, persistor} from './store/store'
import {AuthActions} from 'store/modules/authentication/actions'
import {PersistGate} from 'redux-persist/integration/react'
import './sentry'

const root = ReactDOM.createRoot(document.getElementById('root'))
const accessToken = window.localStorage.getItem(process.env.REACT_APP_AUTH_STORAGE_KEY)
if (accessToken) {
  store.dispatch(AuthActions.reAuthenticate())
}

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
